import { AdminRole, AdminStatus } from './models';

export interface AdminUserFormValue {
  id?: string;
  email: string;
  name: string;
  status: AdminStatus;
  permissions: AdminRole;
}

export function adminUserFormError(form: AdminUserFormValue, currentAdminId?: string): string {
  const email = form.email.trim();
  const name = form.name.trim();
  if (!name) return '中文姓名為必填。';
  if (name.length > 100) return '中文姓名不可超過 100 字。';
  if (!email || email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return '請輸入有效且不超過 254 字的 Email。';
  if (form.id === currentAdminId && form.status === 'DISABLED') return '不可停用目前登入中的帳號。';
  return '';
}
